export default __webpack_public_path__ + "images/794f653cedb6b96138edcc15adfdff24.png";